
export default {
  props: {
    image: {
      type: Object,
      default: () => {}
    },
    reverse: {
      type: Boolean,
      default: false
    },
    productInformation: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    cssClasses () {
      return {
        'align-center': true,
        'flex-row-reverse': this.reverse !== false
      }
    }
  }
}
